import type { LucideIcon } from 'lucide-react';
import { Calendar, Coins, FileText, CircleDot, Paperclip } from 'lucide-react';

const fieldIcon = (Icon: LucideIcon) => <Icon size={18} strokeWidth={2} />;

export const expenseFieldIcons = {
  amount: fieldIcon(Coins),
  expenseDate: fieldIcon(Calendar),
  description: fieldIcon(FileText),
  status: fieldIcon(CircleDot),
  files: fieldIcon(Paperclip),
};
